<template>
    <app-content-admin>
        <template slot="header" >Add Template</template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select
                                        :items="project_list"
                                        :item-text="'project_name'"
                                        :item-value="'project_id'"
                                        :label="$t('Project')"
                                        v-model="form.id_project"
                                        :rules="[rules.required('Project')]"
                                        outlined
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Template Title')"
                                        v-model="form.template_title"
                                        :rules="[
                                            rules.required('Template Title'),
                                        ]"
                                        outlined
                                       
                                    >
                                    </v-text-field>
                                    
                                </v-flex>
                                <v-flex xs12>
                                    <div class="textarea-wrap">
                                        <v-textarea
                                            :label="$t('Template Description')"
                                            v-model="form.template_description"
                                            outlined
                                            maxlength="60" 
  
                                        >
                                        </v-textarea>
                                       <span class="message-counter">{{ form.template_description.length }} / 60</span>
                                    </div>
                                </v-flex>
                             
                                <v-flex xs12>
                                    <v-select
                                        label="Notifcation Type"
                                        outlined
                                        :items="[
                                            'lastest_new',
                                            'event',
                                            'voucher',
                                            'promotion',
                                            'order',
                                            'tool',
                                        ]"
                                        v-model="form.notification_type"
                                    ></v-select>
                                </v-flex>
                                <!-- <v-flex xs12>
                                    <v-file-input
                                        label="File input"
                                        outlined
                                        variant="outlined"
                                        :rules="[fileSizeRule, fileTypeRule]"
                                        v-model="file"
                                        @change="handleFileChange"
                                    ></v-file-input>
                                </v-flex> -->
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="createProject"
                            class="form-submit"
                          
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                id_project: null,
                template_title: null,
                template_description: "",
                notification_type: null,
                file_upload:null,
            },
            file: null,
        };
    },

    components: { ActiveLabel },

    created() {
        let loader = this.$loading.show();

        let token = store.getters["auth/token"];
        axios
            .get(`/api/cloud/get_firebase_project_list?token=${token}`)
            .then((res) => res.data)
            .then((res) => {
                this.project_list = res.data.result.map((item) => {
                    return {
                        project_id: item.id_project,
                        project_name: item.firebase_project_name,
                    };
                });
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
            })
            .finally(() => {
                loader.hide();
            });
    },

    computed: {
        fileSizeRule() {
            return (value) => {
                if (!value) return true;

                const fileSize = value.size / 1024;
                const maxSize = 2048;

                return (
                    fileSize <= maxSize ||
                    `File size should be less than ${maxSize} KB`
                );
            };
        },
        fileTypeRule() {
            return (value) => {
                if (!value) return true;

                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

                return (
                    allowedTypes.includes(value.type) ||
                    "Only JPEG, JPG, and PNG files are allowed"
                );
            };
        },
    },

    methods: {
        async createProject() {
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/create_firebase_template?token=${token}`,
                    this.form
                );

                if (res.data.status == "success") {
                    this.$toastr.s(res.data.data.result);
                }
            } catch (err) {
                this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },

         async uploadFile() {
              const formData = new FormData();
              formData.append("file", this.file);
           let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/upload_image?token=${token}`,formData);

                if (res.data.status == "success") {

                    
                    this.$toastr.s('Upload image Success!');
                    this.form.file_upload = res.data.data.fileName;
                  
                }
            } catch (err) {
                this.$toastr.e('Upload image fail!');
            } finally {
                loader.hide();
            }
        },

        handleFileChange(file) {
            this.file = file;
            this.uploadFile();
        },

        fileChange(e) {
            this.form.firebase_service_account = e.name;
        },
    },
};
</script>

<style>

.textarea-wrap {
  position: relative;
  max-width: 100%;
  margin: auto;
}

.message-counter {
  position: absolute;
  right: 5px;
  bottom: 36px;
  font-size: 13px;
  color: black;
}
</style>
